module.exports = __webpack_public_path__ + "static/media/ifly-there.dbce99a3.jpg";